import React, { useState, useEffect } from 'react'
import { isEqual } from 'lodash'

import DeckLegality from './deckLegality'

import { useActions, useAppSelector } from 'redux/hooks'
import { setDeckStateAction } from 'redux/deck/actions'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import Icon from 'components/elements/Icon'

import styles from './legality.module.scss'

type Status = 'legal' | 'not-legal' | 'bracket-mismatch'

const Legality = () => {
  const [status, setStaus] = useState<Status | null>(null)
  const [errors, setErrors] = useState(new Array<string>())
  const [open, setOpen] = useState(false)

  const cardMap = useAppSelector(state => state.deck.cardMap)
  const format = useAppSelector(state => state.deck.format)
  const categories = useAppSelector(state => state.deck.categories)
  const warningCards = useAppSelector(state => state.deck.warningCards)
  const edhBracket = useAppSelector(state => state.deck.edhBracket)

  const [setDeckState] = useActions(setDeckStateAction)

  useEffect(() => {
    const { errors, cardErrors, onlyBracketErrors } = new DeckLegality(
      cardMap,
      format,
      categories,
      edhBracket,
    ).getErrors()

    setErrors(errors)

    let status: Status = 'legal'

    if (onlyBracketErrors) status = 'bracket-mismatch'
    else if (errors.length) status = 'not-legal'

    setStaus(status)

    // Prevents all cards from rerendering when legality doesn't change
    if (!isEqual(warningCards, cardErrors)) setDeckState({ warningCards: cardErrors })
  }, [cardMap, format, edhBracket])

  if (status === null) return null

  return (
    <>
      {status === 'legal' && (
        <div className={styles.legalMarker}>
          <Icon name="check circle outline" /> Legal
        </div>
      )}

      {status === 'not-legal' && (
        <button className={styles.illegalMarker} onClick={() => setOpen(true)}>
          <Icon name="times circle outline" /> Errors <Icon name="chevron down" />
        </button>
      )}

      {status === 'bracket-mismatch' && (
        <button className={styles.bracketWarning} onClick={() => setOpen(true)}>
          <Icon name="check circle outline" /> Legal - Bracket Mismatch <Icon name="chevron down" />
        </button>
      )}

      <GlobalOverlayStack open={open} onClose={() => setOpen(false)} className={styles.container}>
        <h2>Deck Errors</h2>
        <div className={styles.content}>
          <ul>
            {errors.map((error, key) => (
              <li key={key}>{error}</li>
            ))}
          </ul>
        </div>
      </GlobalOverlayStack>
    </>
  )
}

export default Legality
